import { jsx as _jsx } from "react/jsx-runtime";
import { clsx } from 'clsx';
import classes from './AlertCount.module.css';
export const AlertCount = ({ count, max = 99, size = 'small', variant = 'alert' }) => {
    if (count === undefined) {
        return null;
    }
    return (_jsx("div", { className: clsx(classes.alertCount, classes[size], classes[variant]), children: count > max ? `${max}+` : count }));
};
